import { ModelSagres } from "../../model-sagres";
import { Classificado } from "./classificado";

export class EditalCargo extends ModelSagres {
  id_edital_cargo: number;
  id_edital?: number;
  id_cargo?: number;
  qtd_vagas_ampla: number;
  qtd_vagas_pcd: number;
  qtd_vagas_cotas: number;
  remuneracao_inicial: number;
  cpf_usuario: string;
  localidade: string;
  especialidade: string;
  vl_inscricao_ampla: number;
  qtd_inscritos_ampla: number;
  qtd_inscritos_pcd: number;
  qtd_inscritos_cotas: number;
  dt_criacao: Date;
  dt_alteracao: Date;
  fl_ativo: boolean;
  IdCargoProcessoSeletivo: number | null
  IdCargoNavigation: {
    IdCargo?: number;
    DeCodigoCargo: string;
    DeNomenclaturaCargo: string;
  };
  IdCargoProcessoSeletivoNavigation: {
    IdCargoProcessoSeletivo: number,
    DsNomenclatura: string
  }
  Classificados?: Classificado[];

  constructor(obj?: any) {
    super();
    if (obj) {
      this.id_edital_cargo = obj.IdEditalCargo;
      this.id_edital = obj.IdEdital;
      this.id_cargo = obj.IdCargo;
      this.qtd_vagas_ampla = obj.QtdVagasAmpla;
      this.qtd_vagas_pcd = obj.QtdVagasPcd;
      this.qtd_vagas_cotas = obj.QtdVagasCotas;
      this.remuneracao_inicial = obj.RemuneracaoInicial;
      this.cpf_usuario = obj.cpf_usuario;
      this.localidade = obj.Localidade;
      this.especialidade = obj.Especialidade;
      this.vl_inscricao_ampla = obj.VlInscricaoAmpla;
      this.qtd_inscritos_ampla = obj.QtdInscritosAmpla;
      this.qtd_inscritos_pcd = obj.QtdInscritosPcd;
      this.qtd_inscritos_cotas = obj.QtdInscritosCotas;
      this.dt_criacao = new Date(obj.dt_criacao);
      this.dt_alteracao = new Date(obj.dt_alteracao);
      this.fl_ativo = obj.FlAtivo;
      this.IdCargoProcessoSeletivo = obj.IdCargoProcessoSeletivo;
      this.IdCargoNavigation = {
        IdCargo: obj.IdCargoNavigation?.IdCargo,
        DeCodigoCargo: obj.IdCargoNavigation?.DeCodigoCargo,
        DeNomenclaturaCargo: obj.IdCargoNavigation?.DeNomenclaturaCargo
      };
      this.IdCargoProcessoSeletivoNavigation = {
        IdCargoProcessoSeletivo: obj.IdCargoProcessoSeletivoNavigation?.IdCargoProcessoSeletivo,
        DsNomenclatura: obj.IdCargoProcessoSeletivoNavigation?.DsNomenclatura,
      }
      this.Classificados = obj.Classificados.map((cl: any) => new Classificado(cl))
    }
  }
}
